var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquidGameTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 54,
    viewBox: "0 0 101 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3 51.3H86.5V50.3H83.6V49.2H86.5V48.2H82.3V51.3Z",
    fill: "#CD206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5 52.4H67.4L65.9 49.4L64.5 52.4Z",
    fill: "#CE206B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5C35.2 20.3 35.4 20.2 35.6 20C37 18.6 37.7 16.8 37.7 14.8C37.7 12.8 37 11 35.5 9.49999C34.1 8.09999 32.3 7.29999 30.3 7.29999C28.3 7.29999 26.5 7.99999 25.1 9.49999C23.7 11 23 12.7 23 14.8C23 16.9 23.7 18.6 25.1 20C26.5 21.4 28.3 22.1 30.3 22.1C31.2 22.1 32 22 32.7 21.7L35.9 27.5H38.8L35 20.5ZM33.5 17.8L31.8 14.7H28.9L31.3 19C31 19.1 30.7 19.1 30.4 19.1C29.2 19.1 28.1 18.7 27.3 17.8C26.4 16.9 26 15.9 26 14.7C26 13.5 26.4 12.4 27.3 11.6C28.2 10.7 29.2 10.3 30.4 10.3C31.6 10.3 32.7 10.7 33.5 11.6C34.4 12.5 34.8 13.5 34.8 14.7C34.7 16 34.3 17 33.5 17.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1999 20C79.5999 18.6 80.4 16.8 80.4 14.8C80.4 12.8 79.6999 11 78.1999 9.60002C76.7999 8.20002 75 7.40002 73 7.40002H62.7V22.2H73C75.1 22.1 76.7999 21.4 78.1999 20ZM65.6999 10.3H73C74.2 10.3 75.2999 10.7 76.0999 11.6C76.9999 12.5 77.4 13.5 77.4 14.7C77.4 15.9 76.9999 17 76.1999 17.9C75.2999 18.8 74.2999 19.2 73.0999 19.2H65.6999V10.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6 22.1C48.6 22.1 50.4 21.4 51.8 20C53.2 18.6 54 16.8 54 14.8V0H51V14.8C51 16 50.6001 17.1 49.7001 17.9C48.8001 18.8 47.8 19.2 46.6 19.2C45.4 19.2 44.3 18.8 43.5 17.9C42.6 17 42.2001 16 42.2001 14.8V7.4H39.3V14.8C39.3 16.8 40.0001 18.6 41.4001 20C42.8001 21.4 44.5 22.1 46.6 22.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 7.40002H56.5V22.2H59.4V7.40002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1 17.7C22.1 16.5 21.7 15.4 20.8 14.6C19.9 13.7 18.9 13.3 17.7 13.3H11.8C11.4 13.3 11 13.2 10.7 12.9C10.4 12.6 10.3 12.3 10.3 11.8C10.3 11.4 10.4 11 10.7 10.8C11 10.5 11.3 10.4 11.8 10.4H20.6V7.40002H11.8C10.6 7.40002 9.5 7.80002 8.7 8.70002C7.8 9.60002 7.4 10.6 7.4 11.8C7.4 13 7.8 14.1 8.7 14.9C9.6 15.8 10.6 16.2 11.8 16.2H17.7C18.1 16.2 18.5 16.3 18.7 16.6C19 16.9 19.1 17.2 19.1 17.6C19.1 18 19 18.4 18.7 18.7C18.4 19 18.1 19.1 17.7 19.1H0V22.1H17.7C18.9 22.1 20 21.7 20.8 20.8C21.6 20 22.1 18.9 22.1 17.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8999 30.5V39.4H91.6999V36.4H83.5999V33.5H91.6999V30.5H79.8999Z",
    fill: "#CD206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8 42.3H51.9001L47.8 33.9L43.8 42.3Z",
    fill: "#CD206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4001 42.3L70.8001 33.5V42.3H73.7001V27.6H70.8001L64.9001 38.6L59.0001 27.6H56.1001V48.2H59.0001V33.5L63.4001 42.3H66.4001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 33.5V36.5H33.5L35.1 39.5H27.6C26.4 39.5 25.3 39.1 24.5 38.2C23.6 37.3 23.2001 36.3 23.2001 35.1C23.2001 33.9 23.6 32.8 24.5 32C25.4 31.1 26.4 30.7 27.6 30.7H37.9001L39.1 28.2L39.3 27.8H38.8H36H27.6C25.6 27.8 23.8 28.5 22.4 30C21 31.4 20.3 33.2 20.3 35.2C20.3 37.2 21 39 22.4 40.4C23.8 41.8 25.6 42.5 27.6 42.5H36.8L40.9001 49.9H43.8L35 33.5H27.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 42.3H42.9H43.8L47.8 33.9L51.9 42.3H53.4H55.2L47.8 26.8L40.5 42.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9 30.5H91.7V27.6H77V42.3H91.7V39.4H79.9V30.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6001 36.4H91.7001H100.5V33.5H91.7001H83.6001V36.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3 52.4H64.5L65.9001 49.4L67.4001 52.4H68.6L65.9001 46.9L63.3 52.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9 47.1H68.8V52.4H74.1V51.3H69.9V47.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 49.2V50.3H78.6L79.2 51.4H76.5C76.1 51.4 75.7 51.2 75.4 50.9C75.1 50.6 74.9 50.2 74.9 49.8C74.9 49.4 75.1 49 75.4 48.7C75.7 48.4 76.1 48.2 76.5 48.2H80.2L80.7 47.1H76.5C75.8 47.1 75.1 47.4 74.6 47.9C74.1 48.4 73.8 49 73.8 49.8C73.8 50.6 74.1 51.2 74.6 51.7C75.1 52.2 75.7 52.5 76.5 52.5H79.8L80.4 53.6H81.5L79.2 49.4H76.5V49.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3 52.4H86.5V51.3H82.3V48.2H86.5V47.1H81.3V52.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6001 50.3H86.5001V49.2H83.6001V50.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2 47.1H87.5V52.4H88.6V48.2H91.2C91.3 48.2 91.5 48.3 91.6 48.4C91.7 48.5 91.8 48.6 91.8 48.8C91.8 48.9 91.7 49.1 91.6 49.2C91.5 49.3 91.4 49.4 91.2 49.4H89.4L91.1 52.6H92.1L91 50.3H91.2C91.6 50.3 92 50.1 92.3 49.8C92.6 49.5 92.8 49.1 92.8 48.7C92.8 48.3 92.6 47.9 92.3 47.6C92 47.3 91.6 47.1 91.2 47.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4 47.1H93.3V52.4H94.4V47.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5 47.1V52.4H100.8V51.3H96.6V48.2H100.8V47.1H95.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8 49.2H97.8999V50.3H100.8V49.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.8,
    height: 53.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquidGameTitle);
export default __webpack_public_path__ + "static/media/squidGameTitle.164102d0865b7d05bd7fb5ee3752e9ae.svg";
export { ForwardRef as ReactComponent };